import React from 'react'
import { Typography, Input, Row, Col, Form, Collapse, Space, Button } from 'antd'
import PropTypes from 'prop-types'
import { ImageUploader } from '~components'
import styles from './MarketingPills.module.css'

const { Title } = Typography
const { Panel } = Collapse

const MarketingPills = ({ pills, setPills }) => {
  const handleCTANameChange = (event, index) => {
    const temp = [...pills]
    temp[index] = {
      ...temp[index],
      text: event.target.value
    }
    setPills([...temp])
  }

  const handleCTAUrlChange = (event, index) => {
    const temp = [...pills]
    temp[index] = {
      ...temp[index],
      url: event.target.value
    }
    setPills([...temp])
  }

  const handleImageUrlUpdate = (secureImageURL, index) => {
    const temp = [...pills]
    temp[index] = {
      ...temp[index],
      icon: secureImageURL
    }
    setPills([...temp])
  }

  const handleIconChange = (imgObj, index) => {
    const temp = [...pills]
    temp[index] = {
      ...temp[index],
      icon: imgObj?.url
    }
    setPills([...temp])
  }

  const deletePill = (event, index) => {
    event.stopPropagation()
    const temp = [...pills]
    if (index !== -1) {
      temp.splice(index, 1)
    }
    setPills(temp)
  }

  return (
    <div className={styles['marketing-pill-container']}>
      <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right' style={{ width: '100%' }}>
        {pills?.map((pill, rowIndex) => (<Panel key={rowIndex} extra={<Row gutter={2}><Space>
          <Button danger onClick={(event) => deletePill(event, rowIndex)} style={{ backgroundColor: '#DA0D50', color: '#fff' }}>Delete</Button>
        </Space>
        </Row>
        } header={<span style={{ fontSize: 20 }}>{pill?.text}</span>}>
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Label*</Title></Col>
            <Col>(70 characters max)</Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item><Input maxLength={70} onChange={(event) => handleCTANameChange(event, rowIndex)} value={pill?.text}/></Form.Item>
            </Col>
          </Row>
          {pill && !pill.text && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>}
          <Row align={'left'} className={styles['title-wrapper']}>
            <Col><Title level={3}>Destination URL*</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item><Input onChange={(event) => handleCTAUrlChange(event, rowIndex)} value={pill?.url}/></Form.Item>
            </Col>
          </Row>
          {pill && !pill.url && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>}
          <br />
          <Row align={'left'} className={styles['title-wrapper']} gutter={[10, 10]}>
            <Col><Title level={3}>Icon*</Title></Col>
            <Col><Title level={4}> (Upload PNG or JPG; preferred dimensions 0px x 0px; max file size 1MB)</Title></Col>
          </Row>
          <Row>
            <Col span={24}>
              <ImageUploader handleIconChange ={(imageObj) => handleIconChange(imageObj, rowIndex)} handleUpload={(url) => handleImageUrlUpdate(url, rowIndex)} logoUrl={pill?.icon} />
            </Col>
          </Row>
          {pill && !pill.icon && <Typography.Paragraph className={styles['paragraph-text']}>Please upload an image</Typography.Paragraph>}
        </Panel>))
        }
      </Collapse>
    </div>
  )
}
MarketingPills.propTypes = {
  deletePill: PropTypes.func,
  handleCTANameChange: PropTypes.func,
  handleCTAUrlChange: PropTypes.func,
  handleIconChange: PropTypes.func,
  handleImageUrlUpdate: PropTypes.func,
  pills: PropTypes.array,
  setPills: PropTypes.func
}

export default MarketingPills
